var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3857 2.58398H18.0835V16.4156H10.3857V2.58398Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8747 9.49988C10.8747 6.68961 12.1943 4.19694 14.2225 2.58403C12.732 1.41105 10.8503 0.702393 8.7976 0.702393C3.93437 0.702393 0 4.63677 0 9.49988C0 14.363 3.93437 18.2974 8.79749 18.2974C10.8502 18.2974 12.7319 17.5887 14.2225 16.4156C12.1943 14.8272 10.8747 12.3101 10.8747 9.49988Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4696 9.49988C28.4696 14.3629 24.5352 18.2974 19.6721 18.2974C17.6194 18.2974 15.7378 17.5887 14.2471 16.4156C16.2998 14.8028 17.595 12.3101 17.595 9.49988C17.595 6.68961 16.2753 4.19694 14.2471 2.58403C15.7376 1.41105 17.6194 0.702393 19.6721 0.702393C24.5352 0.702393 28.4696 4.66126 28.4696 9.49988Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/CreditCard.08b4d3642cea8d20ab81fce4adf79096.svg";
export { ForwardRef as ReactComponent };